import { TVersionedResource } from "./interfaces";
import { pathwayVersionedResource } from "app/_modules/pathways/api";
import { reportsVersionedResource, appointmentReportsVersionedResource } from "app/_modules/history/api";
import { subscriptionsVersionedResource, usersVersionedResource } from "app/_modules/user/api";
import { coreVersionedResource } from "app/_modules/core/api";
import { onboardingVersionedResource } from "app/_modules/onboarding/api";

export const API_ROUTE_VERSION: TVersionedResource = {
    ...pathwayVersionedResource,
    ...reportsVersionedResource,
    ...appointmentReportsVersionedResource,
    ...subscriptionsVersionedResource,
    ...usersVersionedResource,
    ...coreVersionedResource,
    ...onboardingVersionedResource,
  };
